import type { Achievement } from "../achievement.types";
import { visitedWords } from "../moveHistory";

export const dejaVuAchievement: Achievement = {
  id: "dejaVu",
  name: "Déjà Vu",
  icon: "repeat",
  description: "Stood on the same word three times in one game.",
  isProgressive: true,
  // Some single word stood on three times (start included, backtracked moves
  // included; a backtrack's landing is not a visit).
  check: (gameReport, gameStatus) => {
    if (!["won", "given_up"].includes(gameStatus) || !gameReport) return false;
    const visits = new Map<string, number>();
    for (const word of visitedWords(gameReport)) {
      const n = (visits.get(word) ?? 0) + 1;
      if (n >= 3) return true;
      visits.set(word, n);
    }
    return false;
  },
};
